import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown", "content"]

  connect() {
    this.updateDropdownPositions()
    this.updateDropdownContentHeight()
    document.addEventListener("turbo:before-stream-render", (event) => this.handleStream(event))
  }

  disconnect() {
    document.removeEventListener("turbo:before-stream-render", (event) => this.handleStream(event))
  }

  updateDropdownPositions() {
    if (this.dropdownTargets.length > 0) {
      const topOffset = this.element.clientHeight
      this.dropdownTargets.forEach((dropdown) => {
        dropdown.style.top = `${topOffset}px`
        // It prevents opening in the wrong position
        dropdown.classList.add("group-hover:visible")
      })
    }
  }

  updateDropdownContentHeight() {
    // Define this target in the dropdown on mobile to enable scrolling only on it
    const announcementsHeight = document.getElementById("announcements")?.clientHeight || 0
    if (this.contentTargets.length > 0) {
      this.contentTargets.forEach((content) => {
        content.style.height = `${announcementsHeight + window.innerHeight - this.element.clientHeight}px`
      })
    }
  }

  handleStream(event) {
    // Update dropdown positions on mobile when the user hides the announcements element
    const streamElement = event.detail.newStream
    const action = streamElement.getAttribute("action")
    const target = streamElement.getAttribute("target")

    if (action === "remove" && target === "announcements") {
      setTimeout(() => this.updateDropdownPositions(), 100)
    }
  }
}
